import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { closeModal, setModalType } from "../../redux/slices/uiSlice";
import ModalWrapper from "./ModalWrapper";
import { useTranslation } from "react-i18next";

const ResetPasswordModal: React.FC = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");

  const handleClose = () => {
    dispatch(closeModal());
  };

  const handleBack = () => {
    dispatch(setModalType("resetLinkSent"));
  };

  const handleSave = () => {
    // Handle save logic here
    dispatch(closeModal());
  };

  return (
    <ModalWrapper onClose={handleClose} showBackButton onBack={handleBack}>
      {/* Header */}
      <div className="text-center lg:mb-[1.2vw] mb-4">
        <h1 className="lg:text-[1.9vw]/[2.2vw] text-2xl/6 font-semibold text-primary-orange lg:mb-[0.3vw] mb-2">
          {t("resetPassword.resetPassword")}
        </h1>
        <p className="lg:text-[1.1vw]/tight text-base/tight text-black-800 font-bold">
          {t("resetPassword.enterNewPassword")}
        </p>
      </div>

      <div className="lg:mb-[1.1vw] md:mb-5 mb-4">
        <div
          className={`relative 2xl:py-[0.6vw] py-2 lg:px-[5%] px-4 flex
    2xl:rounded-[0.26vw] rounded-[5px]
    skew-x-[-10deg]
    2xl:border-[0.104vw] border-[1.5px]
    transition-all border-black-300 2xl:shadow-[0px_0.156vw_0px_#110706] shadow-[0px_2px_0px_#110706]
  `}
        >
          <input
            type="password"
            placeholder={t("resetPassword.newPassword")}
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="2xl:mt-[0.208vw] mt-1 rtl:dir-rtl rtl:text-right w-full  lg:text-[1.1vw]/none md:text-base/none text-sm/none font-bold skew-x-[10deg] text-black-300 placeholder:text-black-400 focus:outline-none transition-all disabled:opacity-50 bg-transparent"
          />
        </div>
      </div>
      <div className="lg:mb-[1.1vw] md:mb-5 mb-4">
        <div
          className={`relative 2xl:py-[0.6vw] py-2 lg:px-[5%] px-4 flex
    2xl:rounded-[0.26vw] rounded-[5px]
    skew-x-[-10deg]
    2xl:border-[0.104vw] border-[1.5px]
    transition-all border-black-300 2xl:shadow-[0px_0.156vw_0px_#110706] shadow-[0px_2px_0px_#110706]
  `}
        >
          <input
            type="password"
            placeholder={t("resetPassword.reEnterPassword")}
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            className="2xl:mt-[0.208vw] mt-1 rtl:dir-rtl rtl:text-right w-full  lg:text-[1.1vw]/none md:text-base/none text-sm/none font-bold skew-x-[10deg] text-black-300 placeholder:text-black-400 focus:outline-none transition-all disabled:opacity-50 bg-transparent"
          />
        </div>
      </div>

      {/* Save Button */}
      <button
        onClick={handleSave}
        className="w-full 2xl:rounded-[0.26vw] rounded-[5px] h-full flex
    skew-x-[-10deg]
    2xl:border-[0.104vw] border-[1.5px] lg:text-[1.1vw]/[1.4vw] md:text-lg/tight text-base/tight font-bold text-primary-yellow bg-primary-yellow border-black-300 transition-all duration-200 cursor-pointer text-center disabled:opacity-50 disabled:cursor-not-allowed 2xl:shadow-[0px_0.156vw_0px_#110706] shadow-[0px_2px_0px_#110706]r"
      >
        <span className="2xl:pt-[0.7vw] pt-2.5 2xl:m-[0.208vw] m-1 !mt-0 2xl:py-[0.5vw] py-2 lg:px-[5%] px-4 2xl:rounded-[0.26vw] rounded-[5px] skew-x-[0deg] !border-t-0 2xl:border-[0.104vw] border-[1.5px] border-black-300 bg-[linear-gradient(180deg,#D76A4D_0%,#B35840_101.89%)] w-full h-full">
          <span className="skew-x-[10deg] block">{t("resetPassword.save")}</span>
        </span>
      </button>
    </ModalWrapper>
  );
};

export default ResetPasswordModal;
